/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StaffSurveyCodeRequest = {
    properties: {
        formId: {
    type: 'number',
    isRequired: true,
    format: 'int32',
},
        employeeIds: {
    type: 'array',
    contains: {
        type: 'EmployeeId',
    },
    isRequired: true,
},
    },
};